import {
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  IconButton,
  Button,
  Radio,
} from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { createIdFromLabel, generateRandomId } from '../../../utils/commonUtils';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import '../custom-multi-select/Custom-Multi-Select.scss';

const CustomSingleSelectCrud = (props) => {
  const {
    item,
    options,
    labelField,
    valueField,
    labelPrefix,
    disabled,
    handleCreate,
    handleEditTag,
    handleDeleteTag,
    handleInputChange,
    classNameProps = '',
  } = props;
  const [selected, setSelected] = useState(null);
  const [addType, setAddType] = useState('');
  const [isShowAddBox, setIsShowAddBox] = useState(false);
  const [editMode, setEditMode] = useState(null);
  const [open, setOpen] = useState(false);
  const inputRef = useRef(null);

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center',
    },
    variant: 'menu',
  };

  useEffect(() => {
    const currSelected = item?.value || null;
    setSelected(currSelected);
  }, [item?.value]);

  useEffect(() => {
    if (selected && options?.length) {
      const updated = options.find((opt) => opt[valueField || 'id'] === selected[valueField || 'id']);
      if (updated && updated[labelField || 'categoryName'] !== selected[labelField || 'categoryName']) {
        setSelected(updated);
        handleInputChange(updated);
      }
    }
  }, [options]);

  useEffect(() => {
    if (isShowAddBox && editMode && inputRef?.current) {
      inputRef?.current?.focus();
      const len = inputRef?.current?.value?.length;
      inputRef?.current?.setSelectionRange(len, len);
    }
  }, [isShowAddBox, editMode]);

  const fieldId = item?.fieldName ? createIdFromLabel(item.fieldName) : generateRandomId();

  const getErrorMessage = () => {
    const errorMsgs = [];
    item?.validations?.forEach((validation) => {
      if (item.errors[validation]) {
        errorMsgs.push(item.errors[validation]);
      }
    });
    return errorMsgs.length > 0 ? errorMsgs[0] : null;
  };

  const handleConfirm = () => {
    if (editMode?.id && addType.trim()) {
      handleEditTag(addType, editMode?.id);
    }
    if (addType.trim() && !editMode) {
      handleCreate(addType);
    }
    setAddType('');
    setIsShowAddBox(false);
    setEditMode(null);
  };

  const handleEdit = (index, e) => {
    e?.stopPropagation();
    setEditMode(options[index]);
    setAddType(options[index]?.[labelField || 'categoryName']);
    setIsShowAddBox(true);
  };

  const handleSelect = (item) => {
    const isAlreadySelected = selected?.id === item?.id;
    if (isAlreadySelected) {
      setSelected(null);
      handleInputChange(null);
    } else {
      setSelected(item);
      handleInputChange(item);
    }
  };

  return (
    <FormControl
      className='custom-multi-select w-100'
      required={item?.validations && item?.validations.includes('required')}
      error={getErrorMessage() ? true : false}
    >
      <InputLabel id={fieldId + '_label'}>
        {labelPrefix} {item?.fieldName}
      </InputLabel>
      <Select
        disabled={disabled}
        labelId={fieldId + '_label'}
        id={fieldId + '_select'}
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => {
          setOpen(false);
          setIsShowAddBox(false);
          setEditMode(null);
          setAddType('');
        }}
        value={selected ? selected[labelField || 'categoryName'] || '' : ''}
        renderValue={() => selected?.[labelField || 'categoryName'] || ''}
        MenuProps={MenuProps}
      >
        {isShowAddBox ? (
          <>
            <div className='addNewType' onMouseDown={(e) => e.stopPropagation()}>
              <Button
                type='text'
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  handleConfirm();
                }}
              >
                <u> Confirm</u>
              </Button>
              <Button
                type='text'
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  setIsShowAddBox(false);
                  setEditMode(null);
                  setAddType('');
                }}
              >
                <u>Cancel</u>
              </Button>
            </div>
            <MenuItem
              className='custom-multi-select-list addNewType'
              value={addType}
              style={{ display: 'flex', alignItems: 'center', padding: '0 20px 0 12px' }}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
            >
              <ListItemIcon style={{ minWidth: 'auto', marginLeft: 10 }}>
                <Radio color='primary' checked={false} />
              </ListItemIcon>
              <input
                ref={inputRef}
                type='text'
                placeholder='Enter Category Name'
                className='addTypeTextBox'
                style={{ flex: 1, marginLeft: 30 }}
                value={addType}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  setAddType(e.target.value);
                }}
              />
            </MenuItem>
          </>
        ) : (
          <div className='addNewType' onMouseDown={(e) => e.stopPropagation()}>
            <Button
              type='text'
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                setIsShowAddBox(true);
              }}
              style={{ color: '#828282' }}
            >
              <u> + Add New</u>
            </Button>
          </div>
        )}
        {options?.map((category, index) => {
          if (editMode?.id === category?.id) {
            return <React.Fragment key={category.id}></React.Fragment>;
          }
          let isChecked = selected?.id === category?.id;
          return (
            <MenuItem
              className='custom-multi-select-list '
              key={category.id}
              value={category[valueField || 'id']}
              style={{ display: 'flex', alignItems: 'center', padding: '0 20px 0 12px' }}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(category);
              }}
            >
              <ListItemIcon style={{ minWidth: 'auto', marginLeft: 10 }}>
                <Radio color='primary' checked={isChecked} />
              </ListItemIcon>
              <ListItemText
                primary={category[labelField || 'categoryName']}
                className={classNameProps}
                style={{ flex: 1, marginLeft: 30 }}
              />
              <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', flexShrink: 0, marginRight: 10 }}>
                <IconButton
                  style={{ padding: 4, zIndex: 3 }}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEdit(index, e);
                  }}
                >
                  <EditIcon sx={{ fontSize: 14 }} />
                </IconButton>
                <IconButton
                  style={{ padding: 4, zIndex: 3 }}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteTag(category?.id);
                  }}
                >
                  <DeleteForeverIcon sx={{ fontSize: 14 }} />
                </IconButton>
              </div>
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>{getErrorMessage()}</FormHelperText>
    </FormControl>
  );
};

export default CustomSingleSelectCrud;
